<template>
  <div
    class="productTableCom"
    v-if="
      pageType === orderPageTypeName ||
      pageType === salesPageTypeName ||
      pageType === stockMovePageTypeName ||
      pageType === stockAdjustPageTypeName
    "
  >
    <v-data-table
      :headers="headers"
      :items="items"
      :item-key="itemKey"
      :hide-default-header="false"
      hide-default-footer
      class="rounded-lg"
      :items-per-page="-1"
      :no-data-text="$t('common.common_no-history')"
    >
      <template v-slot:[`item.changeAt`]="{ item }">
        {{ getDateFromDateTimeString(item.changeAt) }}
      </template>
      <template v-slot:[`item.beforeStatusId`]="{ item }">
        <!-- {{ getStatusName(item.type, item.beforeStatusId) }} -->

        {{ getBeforeStatusList(item.beforeStatusId) }}
      </template>
      <template v-slot:[`item.afterStatusId`]="{ item }">
        <!-- {{ getStatusName(item.type, item.afterStatusId) }} -->

        {{ getAfterStatusList(item.afterStatusId) }}
      </template>
      <template v-slot:[`item.userId`]="{ item }">
        {{ item.user.lastName + item.user.firstName }}
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {
  commonUtil,
  orderUtil,
  saleUtil,
  stockMoveUtil,
  stockAdjustUtil
} from '@/util'
import lu from '@/util/languageUtil'

export default {
  components: {},
  props: {
    pageType: { default: '' },
    items: [],
    itemKey: String
  },
  data: () => ({
    pageTypeName: 'StatusHistory',

    orderPageTypeName: '',
    salesPageTypeName: '',
    stockMovePageTypeName: '',
    stockAdjustPageTypeName: ''
  }),
  computed: {
    headers() {
      return [
        {
          text: lu.t('common.common_change-date'),
          value: 'changeAt',
          sortable: false,
          width: '25%'
        },
        {
          text: lu.t('common.common_change-before'),
          value: 'beforeStatusId',
          sortable: false,
          width: '25%',
          class: 'rgba(151, 198, 234, 0.1)'
        },
        {
          text: lu.t('common.common_after-change'),
          value: 'afterStatusId',
          sortable: false,
          width: '25%',
          class: 'rgba(151, 198, 234, 0.1)'
        },
        {
          text: lu.t('common.common_changer'),
          value: 'userId',
          sortable: false,
          width: '25%',
          class: 'rgba(151, 198, 234, 0.1)'
        }
      ]
    }
  },
  methods: {
    getBeforeStatusList(id) {
      if (this.pageType === this.orderPageTypeName) {
        const idList = [
          { id: 1, name: '入庫未完成' },
          { id: 2, name: '発注未完成' },
          { id: 3, name: '入庫済' },
          { id: 4, name: '発注完成' },
          { id: 5, name: '出金未完成' },
          { id: 6, name: '出金済' }
        ]
        return idList.find((ele) => ele.id === Number(id)).name
      } else if (this.pageType === this.salesPageTypeName) {
        const idList = [
          { id: 1, name: '入金未完成' },
          { id: 2, name: '出庫未完成' },
          { id: 3, name: '注文未完成' },
          { id: 4, name: '入金済' },
          { id: 5, name: '出庫済' },
          { id: 6, name: '注文完成' },
          { id: 7, name: '確認中' },
          { id: 8, name: '出荷予定登録中' },
          { id: 9, name: '出荷予定通知済み' }
        ]
        return idList.find((ele) => ele.id === Number(id)).name
      } else if (this.pageType === this.stockMovePageTypeName) {
        return stockMoveUtil.getStockMoveStatusName(id)
      } else if (this.pageType === this.stockAdjustPageTypeName) {
        return stockAdjustUtil.getStockAdjustStatusNameForHistory(id)
      }
    },
    getAfterStatusList(id) {
      if (this.pageType === this.orderPageTypeName) {
        const idList = [
          { id: 1, name: '入庫未完成' },
          { id: 2, name: '発注未完成' },
          { id: 3, name: '入庫済' },
          { id: 4, name: '発注完成' },
          { id: 5, name: '出金未完成' },
          { id: 6, name: '出金済' },
          { id: 99, name: '無効' }
        ]
        return idList.find((ele) => ele.id === Number(id)).name
      } else if (this.pageType === this.salesPageTypeName) {
        const idList = [
          { id: 1, name: '入金未完成' },
          { id: 2, name: '出庫未完成' },
          { id: 3, name: '注文未完成' },
          { id: 4, name: '入金済' },
          { id: 5, name: '出庫済' },
          { id: 6, name: '注文完成' },
          { id: 7, name: '確認中' },
          { id: 8, name: '出荷予定登録中' },
          { id: 9, name: '出荷予定通知済み' },
          { id: 99, name: '無効' }
        ]
        return idList.find((ele) => ele.id === Number(id)).name
      } else if (this.pageType === this.stockMovePageTypeName) {
        return stockMoveUtil.getStockMoveStatusName(id)
      } else if (this.pageType === this.stockAdjustPageTypeName) {
        return stockAdjustUtil.getStockAdjustStatusNameForHistory(id)
      }
    },

    // getStatusName(type, id) {
    //   const list = this.getStatusList(type)
    //   return commonUtil.getStatusHistoryLabelById(list, id)
    // },
    // getStatusList(type) {
    //   if (this.pageType === this.orderPageTypeName) {
    //     return orderUtil.getStatusListByType(type)
    //   } else if (this.pageType === this.salesPageTypeName) {
    //     return saleUtil.getStatusListByType(type)
    //   }
    // },

    getDateFromDateTimeString(data) {
      return commonUtil.getDateFromDateTimeString(data)
    }
  },
  created() {
    this.orderPageTypeName = 'Order' + this.pageTypeName
    this.salesPageTypeName = 'Sales' + this.pageTypeName
    this.stockMovePageTypeName = 'StockMove' + this.pageTypeName
    this.stockAdjustPageTypeName = 'StockAdjust' + this.pageTypeName
  }
}
</script>
<style lang="scss" scoped>
.productTableCom {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    padding-left: 30px;
  }
  ::v-deep .v-data-table td {
    padding-left: 30px;
  }
}
</style>
